__turbopack_context__.v({
  "body": "page-module__9TDtia__body",
  "calculateButton": "page-module__9TDtia__calculateButton",
  "diagram": "page-module__9TDtia__diagram",
  "hero": "page-module__9TDtia__hero",
  "heroInner": "page-module__9TDtia__heroInner",
  "heroTitle": "page-module__9TDtia__heroTitle",
  "input": "page-module__9TDtia__input",
  "label": "page-module__9TDtia__label",
  "page": "page-module__9TDtia__page",
  "placeholderHint": "page-module__9TDtia__placeholderHint",
  "select": "page-module__9TDtia__select",
  "table": "page-module__9TDtia__table",
  "thenumber": "page-module__9TDtia__thenumber",
  "unit": "page-module__9TDtia__unit",
  "well": "page-module__9TDtia__well",
});
